<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      {{ 'tableManagement.employee.title' | translate }}
    </div>
  </ng-template>
  <!-- #endregion -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>
      <!-- NAME -->
      <th pSortableColumn="code">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.name' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='code'></p-sortIcon>
            <p-columnFilter field='user' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- DATE BIRTH -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.birthDate' | translate }}
          </div>
        </div>
      </th>

      <!-- NIF -->
      <th pSortableColumn="nif">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.nif' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='nif'></p-sortIcon>
            <p-columnFilter field='nif' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- DATE EXPIRATION NIF -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.expirationDateNif' | translate }}
          </div>
        </div>
      </th>

      <!-- DATE EXPEDITION NIF -->
      <th>
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.form.expeditionDateNif' | translate }}
          </div>
        </div>
      </th>

      <!-- DELEGATION -->
      <th pSortableColumn="subdivision.division.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.division' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='subdivision.division.code'></p-sortIcon>
            <p-columnFilter field='division' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- SUBDELEGATION -->
      <th pSortableColumn="subdivision.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.subdivision' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='subdivision.code'></p-sortIcon>
            <p-columnFilter field='subdivision' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- BILLING ACCOUNT -->
      <th pSortableColumn="ceco.billingAccount.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.company' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='ceco.billingAccount.code'></p-sortIcon>
            <p-columnFilter field='billingAccount' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- CECO -->
      <th pSortableColumn="ceco.code">
        <div class='d-flex align-items-center justify-content-center flex-fill h-100'>
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'drivers.table.ceco' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='ceco.code'></p-sortIcon>
            <p-columnFilter field='ceco' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- ACTIVE -->
      <th pSortableColumn='disabled'>
        <div class='d-flex align-items-center h-100'>

          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'general.active' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='disabled'></p-sortIcon>
            <p-columnFilter field='disabled' type='boolean' display='menu' [showApplyButton]="false"></p-columnFilter>
          </div>

        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-employee>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(employee)">

      <!-- SELECT -->
      <td>
        <div class="d-flex justify-content-center">
          <p-tableCheckbox [value]="employee"></p-tableCheckbox>
        </div>
      </td>

      <!-- NAME -->
      <td>
        ({{employee.code}}) {{employee.user?.surname1}} {{employee.user?.surname2}}, {{employee.user?.name}}
      </td>

      <!-- DATE BIRTH-->
      <td>
        {{employee.user?.birthDate | date: 'dd/MM/yyyy'}}
      </td>

      <!-- NIF -->
      <td>
        {{employee.nif}}
      </td>

      <!-- DATE NIF EXPIRATION -->
      <td>
        {{employee.nifExpirationDate | date: 'dd/MM/yyyy'}}
      </td>

      <!-- DATE NIF EXPEDITION -->
      <td>
        {{employee.nifExpeditionDate | date: 'dd/MM/yyyy'}}
      </td>

      <!-- DIVISION -->
      <td>
        ({{employee.subdivision?.division.code}}) {{employee.subdivision?.division.name}}
      </td>

      <!-- SUBDIVISION -->
      <td>
        ({{employee.subdivision?.code}}) {{employee.subdivision?.name}}
      </td>

      <!-- EMPRESA -->
      <td>
        ({{employee.ceco?.billingAccount.code}}) {{employee.ceco?.billingAccount.name}}
      </td>

      <!-- CECO -->
      <td>
        ({{employee.ceco?.code}}) {{employee.ceco?.description}}
      </td>

      <!-- ACTIVE -->
      <td>
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
          [ngClass]="{'true-icon pi-check-circle': !employee.disabled, 'false-icon pi-times-circle': employee.disabled}"></i>
        </div>
      </td>
    </tr>

  </ng-template>
  <!-- TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="11" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
          {{ 'table.tableEmptyMessage' | translate }}!
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="11" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">

          <!-- ADD DRIVER BUTTON -->
          <app-table-add-button [text]="'tableManagement.employee.employees' | translate " (btnClick)="create()"
          [isDisabled]='!isCreateGranted'></app-table-add-button>

          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="selectedEntities.length === 0 || !isDisabledGranted"></app-table-change-status-button>

          <!-- ADD USER BUTTON -->
          <button class='btn d-flex align-items-center gap-2 table-add-button' type='button' (click)="openUserForm()"[disabled]="selectedEntities.length != 1 || !isCreateUserGranted">
            <!-- BUTTON ICON -->
            <span class='d-flex align-items-center justify-content-center'>
              <svg-icon src='assets/icons/plus.svg'
                class='d-flex align-items-center justify-content-center'
                [svgStyle]="{'height.px': 15, 'width.px': 15}"
              ></svg-icon>
            </span>

            <!-- BUTTON TEXT -->
            <span class='ms-auto me-auto'>
              {{ 'tableManagement.employee.buttonUserCreate' | translate }}
            </span>

          </button>

          <!-- EXCEL BUTTON -->
          <app-table-excel-button class="buttonTableExcel" (btnClick)="exportExcel()"></app-table-excel-button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>


<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
  <div>
    <app-change-status-shared [items]=" 'tableManagement.employee.employees' | translate " [display]="true" [service]=employeeService
      [entitiesList]=selectedEntities (return)="refreshList($event)"
    (close)="closeStatusDialog($event)"></app-change-status-shared>
  </div>
}

<!-- DRIVER INFO CARD -->
<app-employee-form></app-employee-form>
<app-user-form [virtualUser]="false"></app-user-form>